import React from 'react';
import styled from 'styled-components';
import { string, bool } from 'prop-types';
import { spacing } from 'TMDesignSystem/spacing';

const Heading = styled.h2`
    font-size: ${spacing.large};
    font-weight: 700;
    color: ${({ theme }) => theme.colorSystem.primary[1]};
    margin: 20px 0 ${spacing.mediumLarge} 0;

    span {
        color: ${({ theme }) => theme.colorSystem.secondary[3]};
    }
`;

const SectionHeading = ({ text, showDot }) => (
    <Heading>
        {text}
        {showDot && <span>.</span>}
    </Heading>
);

SectionHeading.propTypes = {
    text: string.isRequired,
    showDot: bool
};

SectionHeading.defaultProps = {
    showDot: true
};

export default SectionHeading;
